import { ContextProviderProps } from 'config/types'
import {
  createContext,
  Dispatch,
  SetStateAction,
  useCallback,
  useState,
} from 'react'

interface GalleryContextType {
  galleryImages: string[]
  setGalleryImages: Dispatch<SetStateAction<string[]>>
  addImage: (url: string) => void
  removeImage: (index: number) => void
  addImageOnlyOnce: (urls: string[]) => void
}

const GalleryContext = createContext<GalleryContextType>({
  galleryImages: [],
  setGalleryImages: () => {},
  addImage: () => {},
  removeImage: () => {},
  addImageOnlyOnce: () => {},
})

const GalleryProvider = ({ children }: ContextProviderProps) => {
  const [galleryImages, setGalleryImages] = useState<string[]>([])
  const [init, setInit] = useState(false)

  const addImage = useCallback((url: string) => {
    setGalleryImages(prev => [...prev, url])
  }, [])

  const removeImage = useCallback((index: number) => {
    setGalleryImages(prev => prev.filter((_, i) => i !== index))
  }, [])

  const addImageOnlyOnce = useCallback(
    (urls: string[]) => {
      if (!init) {
        setGalleryImages(urls)
        setInit(true)
      }
    },
    [init]
  )

  return (
    <GalleryContext.Provider
      value={{
        galleryImages,
        setGalleryImages,
        addImage,
        removeImage,
        addImageOnlyOnce,
      }}
    >
      {children}
    </GalleryContext.Provider>
  )
}

export { GalleryProvider, GalleryContext }
